import { Content, FormatContent } from 'src/contexts/ContentContext';
import { PosProgressBar } from 'src/core/POS/PosProgressBar/PosProgressBar';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import { FormatContentId } from 'src/utils/constants/formatContentId';

import { SlotCreationStatus } from '../EventGroup.types';
import * as styles from './EventGroupCreatingStep.css';

type EventGroupCreatingStepProps = {
  count: number;
  statuses: SlotCreationStatus[];
};

export const EventGroupCreatingStep = ({
  count,
  statuses,
}: EventGroupCreatingStepProps) => {
  // A slot counts as processed once it has settled (created or errored); the bar
  // fills as each one finishes and reaches 100% when the whole batch is done.
  const processed = statuses.filter(
    (status) => status === 'done' || status === 'error'
  ).length;
  const progressValue = count > 0 ? (processed / count) * 100 : 0;

  return (
    <Stack direction="column" gap="l" className={styles.container}>
      <div>
        <div className={styles.title}>
          <Content id={ContentId.CreatingEventGroup} />
        </div>
        <div className={styles.subtitle}>
          <Content id={ContentId.CreatingPlaceholderEventsDescription} />
        </div>
      </div>

      <Stack direction="column" gap="s" width="full">
        <PosProgressBar value={progressValue} style={{ width: '100%' }} />
        <span className={styles.progressLabel}>
          <FormatContent
            id={FormatContentId.ValueOfValue}
            params={[String(processed), String(count)]}
          />
        </span>
      </Stack>
    </Stack>
  );
};
